import React from "react";
import { useLocation } from "react-router-dom";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import UpdateConfirmationChild from "./UpdateConfirmationChild";

const UpdateConfirmation = () => {
  const { state } = useLocation();
  const confirmationRecord = state;
  return (
    <MainTemplate>
      <ErrorBoundaryRoutes route="/confirmation/add" page="AddConfirmation">
        <div className="relative flex flex-col p-10 m-3 space-y-10 bg-white rounded-md shadow md:flex-row md:space-y-0 md:m-3">
          <UpdateConfirmationChild confirmationRecord={confirmationRecord} />
        </div>
      </ErrorBoundaryRoutes>
    </MainTemplate>
  );
};

export default UpdateConfirmation;
